<template>
	<!-- If it's a product we need to show a special list item -->
	<li v-if="card.contentType === 'ProductBase'" class="c-global-search-autosuggestions__item">
		<a :href="card.url"
			:ref="`card_${card.id}`"
		   	class="c-global-search-autosuggestions__product-link c-global-search-autosuggestions__product-link--no-underline h-focus-outline "
			data-testid="product-link"
			tabindex="-1">
			<img
				:src="card.imageUrl"
				 :alt="card.heading"
				 class="c-global-search-autosuggestions__product-link-image" />
			<div class="c-global-search-autosuggestions__product-link-text">
				<ds-text text-style="regular" text-type="body-sm" html-element="p" class="c-global-search-autosuggestions__product-color-muted">{{card.properties?.manufacturerName}}</ds-text>
				<ds-text text-style="bold" text-type="heading-md" html-element="h3" class="c-global-search-autosuggestions__product-color-default">{{ card.heading }}</ds-text>

				<!-- show variantFieldsForAutoSuggest field -->
				<ds-text v-for="item in card.properties?.variantFieldsForAutoSuggest" text-style="regular" text-type="body-sm" html-element="p" class="c-global-search-autosuggestions__product-color-muted">{{item}}</ds-text>

			</div>
		</a>
	</li>
	<li v-else class="c-global-search-autosuggestions__item">
		<a :href="card.url"
		   :target="card.contentType === 'PdfFile' ? '_blank' : null"
		   class="c-global-search-autosuggestions__link c-global-search-autosuggestions__product-link--no-underline h-focus-outline"
		   :ref="`card_${card.id}`"
		   tabindex="-1">
		</a>
		<p v-if="card.categoryTags && card.categoryTags.value">
			{{ card.categoryTags.value }}
		</p>
		<h3 v-if="card.heading"
			class="c-global-search-autosuggestions__title">
			{{ card.heading }}
		</h3>
	</li>
</template>

<script>
	import {DsText} from "@coloplast/design-system";

	export default {
		name: 'global-search-autoSuggest-item',
		components: {DsText},
		props: ['card'],
		methods: {
			focusElement() {
				this.$refs[`card_${this.card.id}`].focus()
			}
		}
	};
</script>
